export default __webpack_public_path__ + "static/media/Rod Vilhauer.103fa8d4.png";